import { isDataSharingOptedOut } from 'chairisher/context/account';

/**
 * @type {Array.<Object>}
 */
let fbqQueue = [];

/**
 * Id of the interval being used to flush the facebook event queue
 *
 * @type {number|null}
 */
let fbqQueueIntervalId = null;

/**
 * Sends enqueued facebook events that occurred before facebook was loaded
 */
function purgeFbqQueue() {
    for (let i = 0; i < fbqQueue.length; i += 1) {
        window.fbq.apply(window.fbq, fbqQueue[i]);
    }

    fbqQueue = [];
}

/**
 * Sends Facebook a conversion event
 *
 * @param {Array} eventData Event data to pass to Facebook
 */
export function logFacebookEvent(eventData) {
    if (window.fbq) {
        window.fbq.apply(window.fbq, eventData);
    } else {
        fbqQueue.push(eventData);

        if (!fbqQueueIntervalId) {
            fbqQueueIntervalId = window.setInterval(() => {
                if (window.fbq) {
                    window.clearInterval(fbqQueueIntervalId);
                    fbqQueueIntervalId = null;
                    purgeFbqQueue();
                }
            }, 1000);
        }
    }
}

/**
 * Tracks a Facebook CompleteRegistration conversion (email collection)
 */
export function trackFacebookRegistrationConversion() {
    if (!isDataSharingOptedOut()) {
        logFacebookEvent(['track', 'CompleteRegistration']);
        logFacebookEvent(['track', 'Lead']);
    }
}
